  import React from 'react';
  import Navbar from '../Navbar';
  import Footer from '../Footer';
  import { ShieldCheck, Settings, Zap } from 'lucide-react';
  import PowerSystemSolutions from '../PowerSystemSolutions';
  import Topimage from '../images/Hero1.jpg';
  import Pic1 from "../images/g1.jpg";
  import Pic2 from "../images/g2.jpg";
  import Pic3 from "../images/g3.jpg";
  import Pic4 from "../images/g5.jpg";
  import image from "../images/g4.jpg";

const showcaseImages = [
  {
    src: Pic1,
    alt: 'Panel Design ',
    description: 'A corridor view of a high-voltage indoor switchgear room with circuit breakers, control indicators, and relay panels. Suitable for industrial or power utility control centers.'
  },
  {
    src: Pic2,
    alt: 'Switchgear Equipment',
    description: 'Detailed view of internal terminal blocks and wiring in a low-voltage Panel Design, showcasing organized control wiring and modular design.'
  },
  {
    src: Pic3,
    alt: 'Electrical Control Console',
    description: 'Front-facing view of an analog/digital hybrid control panel with meters, pushbuttons, and selector switches. Ideal for centralized electrical system monitoring.'
  },
  {
    src: Pic4,
    alt: 'Industrial Switchgear Room (Dimly lit)',
    description: 'Dimly lit power distribution room with multiple metal-clad switchgear cabinets, emphasizing critical infrastructure and 24/7 operational readiness.'
  }
];


  function Switchgear() {
    return (
      <>
        <Navbar />

        {/* Hero Image with Overlay Text */}
        <div className="relative pt-4">
          <img
            src={Topimage}
            alt="Switchgear top visual"
            className="w-full max-h-[500px] object-cover object-center"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black/40">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center">
             Panel Design 
            </h2>
          </div>
        </div>

        {/* Hero Section with Background Image */}
        <section className="relative bg-white py-16 px-6 sm:px-10 lg:px-20 overflow-hidden">
          <img
            src={image}
            alt="Power substation background"
            className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none"
            aria-hidden="true"
          />
          <div className="relative max-w-7xl mx-auto text-center md:text-left">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
             Safety Panel Design & Engineering
            </h1>
            <p className="text-gray-700 max-w-3xl leading-relaxed mx-auto md:mx-0">
              We offer comprehensive Panel design and integration services to ensure reliable and safe power distribution for industrial and commercial clients.
            </p>
          </div>
        </section>

        {/* Features Section */}
        <section className="bg-gray-50 py-16 px-6 sm:px-10 lg:px-20">
          <div className="max-w-7xl mx-auto text-center md:text-left">
            <h2 className="text-3xl font-bold text-gray-900 mb-10">Our Panel Design Expertise</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              {[
                {
                  icon: ShieldCheck,
                  title: "Safety & Protection",
                  desc: "Comprehensive protection systems ensuring equipment and personnel safety through advanced relay and breaker coordination."
                },
                {
                  icon: Settings,
                  title: "Custom Design & Integration",
                  desc: "Tailored switchgear configurations to meet your exact load requirements and system architecture with seamless integration."
                },
                {
                  icon: Zap,
                  title: "High Performance & Reliability",
                  desc: "State-of-the-art switchgear solutions designed for long-lasting operation even in the most demanding environments."
                }
              ].map(({ icon: Icon, title, desc }, i) => (
                <div
                  key={i}
                  className="bg-white p-6 rounded-lg shadow hover:shadow-md transition flex flex-col items-center md:items-start text-center md:text-left"
                >
                  <div className="text-blue-600 mb-4">
                    <Icon className="w-10 h-10" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{title}</h3>
                  <p className="text-gray-700 text-sm">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <PowerSystemSolutions />

        {/* Image Showcase */}
        <section className="bg-white py-16 px-6 sm:px-10 lg:px-20">
          <div className="max-w-7xl mx-auto text-center md:text-left">
            <h2 className="text-3xl font-bold text-gray-900 mb-10">Panel Designs (2D & 3D)</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {showcaseImages.map(({ src, alt, description }, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded-x  l shadow-lg cursor-pointer transform transition duration-300 hover:scale-105 bg-white p-3"
              >
                <img
                  src={src}
                  alt={alt}
                  className="w-full h-52 object-cover rounded-lg mb-4"
                  loading="lazy"
                />
                <p className="text-sm text-gray-700 font-semibold">{alt}</p>
                <p className="text-xs text-gray-500 mt-1">{description}</p>
              </div>
            ))}
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="bg-blue-600 py-12 text-white text-center">
          <h3 className="text-2xl font-bold mb-3">Need reliable switchgear solutions?</h3>
          <p className="mb-5 text-sm max-w-xl mx-auto">
            Contact us to optimize your power distribution systems with safe and efficient switchgear design.
          </p>
          <a
            href="/#contact"
            className="inline-block bg-white text-blue-600 font-semibold px-6 py-3 rounded-md shadow hover:bg-gray-100 transition"
          >
            Get in Touch
          </a>
        </section>

        <Footer />
      </>
    );
  }

  export default Switchgear;
